import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { CadencePlaybookStep } from "../PlaybookStore";
import ApplicationStore from "../../../stores/ApplicationStore";
import { ApiResponseType } from "../../../types";
import { client } from "../../../utils/axios-client";

const loadRecords = (cadenceId: string) => client.get('/api/playbooks/cadence/steps', { params: { cadenceId: cadenceId } }).then((res) => res.data);
const updateCadenceStep = async (data: { items: CadencePlaybookStep[] }) => {
    var response = await client.post('/api/playbooks/cadence/steps', data);
    return response.data;
};

const useCadenceSteps = (cadenceId: string) => {
    const [steps, setSteps] = useState<CadencePlaybookStep[]>([])
    const [updatedSteps, setUpdatedSteps] = useState<CadencePlaybookStep[]>([])
    const [dirty, setDirty] = useState(false);
    const queryClient = useQueryClient();

    const { mutate, isLoading: isSaving } = useMutation(updateCadenceStep, {
        onSuccess: data => {
            console.log(data);
            
            const message = "success"
        },
        onError: () => {
            alert("there was an error")
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: ['cadenceSteps'] });
        }
    });

    const { data, isLoading, isError, error, refetch } = useQuery<CadencePlaybookStep[]>(
        {
            queryKey: ['cadenceSteps'], queryFn: () => loadRecords(cadenceId),
            onSuccess: (data) => {                
                setSteps(data);
                setUpdatedSteps(data);
            }
        });

    useEffect(() => {
        refetch();
    }, [cadenceId])

    const deleteCandenceStep = async (row: CadencePlaybookStep) => {
        const response = await client.delete<ApiResponseType>('/api/playbooks/cadence/steps', { params: { cadenceStepId: row.id } });

        if (response.data.succeeded) {
            await refetch();

            ApplicationStore.update(s => {
                s.snackbarMessage = "Cadence step successfully deleted";
                s.snackbarOpen = true;
            });
        } else {
            alert('Error while deleting cadence step.');
        }
    }

    const updateStep = (row: CadencePlaybookStep) => {
        const temp = structuredClone(updatedSteps);

        const itemIndex = temp.findIndex(s => s.id === row.id);

        if (itemIndex > -1) {
            temp[itemIndex] = row;
        }

        setDirty(true);
        setUpdatedSteps(temp);
    }

    const updateSteps = (rows: CadencePlaybookStep[]) => {        
        setDirty(true);
        setUpdatedSteps(rows);
    }

    const addRow = async (activityTypeId: string) => {
        const newItems = [...updatedSteps];

        const newRow = {
            id: crypto.randomUUID(),
            currentActivityId: activityTypeId,
            playbookCadenceId: cadenceId,
            processOrder: newItems.length + 1,
            processWhen: 0,
            autoSend: false
        } as unknown as CadencePlaybookStep;

        newItems.push(newRow);

        setUpdatedSteps(newItems);
        setDirty(true);
    }

    const save = async () => {        
        await mutate({ items: updatedSteps });
        setSteps(updatedSteps);
    }

    const cancel = () => {
        setUpdatedSteps(steps);
    }

    return { steps: updatedSteps, isLoading, deleteCandenceStep, updateStep, updateSteps, dirty, addRow, isError, save, cancel }
}

export default useCadenceSteps;